import React from 'react';
import SiteLayout from '../../layouts/SiteLayout';
import Header from '../../components/Header/Header';

const TenantNotificationsScreen: React.FC = () => {
    return (
        <SiteLayout>
            <Header icon='notifications' title='Configuration des Notifications' />
            <div style={{ padding: '20px', maxWidth: '1400px', margin: '0 auto' }}>
                <div className="box" style={{ padding: '20px' }}>
                    <div style={{ marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid #eee' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <h4 style={{ fontWeight: 'bold', marginBottom: '5px' }}>Alertes par Email</h4>
                                <p style={{ color: '#666', fontSize: '0.9rem' }}>Recevoir des emails pour les événements importants.</p>
                            </div>
                            <label className="switch">
                                <input type="checkbox" defaultChecked />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>

                    <div style={{ marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid #eee' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <h4 style={{ fontWeight: 'bold', marginBottom: '5px' }}>Rapports Hebdomadaires</h4>
                                <p style={{ color: '#666', fontSize: '0.9rem' }}>Recevoir un résumé de l'activité chaque semaine.</p>
                            </div>
                            <label className="switch">
                                <input type="checkbox" />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </SiteLayout>
    );
};

export default TenantNotificationsScreen;
